import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlugin2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="plugin-2, build"><path d="M4 3.75C4 3.33579 4.33579 3 4.75 3H10.25C10.6642 3 11 3.33579 11 3.75V7H4V3.75Z" fill="currentColor"/><path d="M13 3.75C13 3.33579 13.3358 3 13.75 3H19.25C19.6642 3 20 3.33579 20 3.75V7H13V3.75Z" fill="currentColor"/><path d="M2 9.25C2 8.83579 2.33579 8.5 2.75 8.5H21.25C21.6642 8.5 22 8.83579 22 9.25V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V9.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPlugin2;
